var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require("../assets/icon/error.svg"),"alt":""}}),_c('p',[_vm._v("错误: "+_vm._s(_vm.msg))]),_c('div',{staticClass:"bnt-pay"},[_c('div',{staticClass:"bnt-pay-text",on:{"click":_vm.close}},[_vm._v(" 关闭 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }